import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import sanitizeHtml from 'sanitize-html'
import { content_block } from './data/content_block.json';
import { lobRoot } from "../../utils/LobLogicModule";
import './ContentBlock.scss';

const ContentBlock = () => {
    const { t } = useTranslation('content_block');
	return ( 
        <div className='contentblock container_wrapper contentblock__bg'>
            <div className='contentblock__wrapper'>
                <div className='contentblock__column'>
                    <h2 className='contentblock__heading' dangerouslySetInnerHTML={{ __html: lobRoot === '/' ? t(content_block.db.heading) : lobRoot === '/sb' ? t(content_block.sb.heading) : ''}}></h2>
                    <p className='contentblock__copy' dangerouslySetInnerHTML={{ __html: lobRoot === '/' ? t(content_block.db.copy) : lobRoot === '/sb' ? t(content_block.sb.copy) : ''}}></p>
                    <Link id="contentblock__cta" to={sanitizeHtml(lobRoot === '/' ? t(content_block.db.ctaURL) : lobRoot === '/sb' ? t(content_block.sb.ctaURL) : '')} className="contentblock__link t-track-cta" target="_blank" rel="noopener noreferrer" dangerouslySetInnerHTML={{ __html: lobRoot === '/' ? t(content_block.db.cta) : lobRoot === '/sb' ? t(content_block.sb.cta) : ''}} data-bactmln="ContentBlock-_-CTA-_-CheckItOut"></Link>
                </div>
            </div>
        </div>
    )
}

export default ContentBlock;